var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "14px",
    viewBox: "0 0 11 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "settings-power-sharp-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Space-Fix",
    transform: "translate(-1018.000000, -19.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(1018.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-power-sharp-24px",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.90909091,14 L3.18181818,14 L3.18181818,12.7272727 L1.90909091,12.7272727 L1.90909091,14 Z M4.45454545,14 L5.72727273,14 L5.72727273,12.7272727 L4.45454545,12.7272727 L4.45454545,14 Z M5.72727273,0 L4.45454545,0 L4.45454545,6.36363636 L5.72727273,6.36363636 L5.72727273,0 Z M7.99272727,1.55272727 L7.07,2.47545455 C8.17090909,3.14363636 8.90909091,4.34636364 8.90909091,5.72727273 C8.90909091,7.83363636 7.19727273,9.54545455 5.09090909,9.54545455 C2.98454545,9.54545455 1.27272727,7.83363636 1.27272727,5.72727273 C1.27272727,4.34636364 2.01090909,3.14363636 3.10545455,2.46909091 L2.18909091,1.55272727 C0.865454545,2.46909091 0,3.99636364 0,5.72727273 C0,8.54 2.27818182,10.8181818 5.09090909,10.8181818 C7.90363636,10.8181818 10.1818182,8.54 10.1818182,5.72727273 C10.1818182,3.99636364 9.31636364,2.46909091 7.99272727,1.55272727 Z M7,14 L8.27272727,14 L8.27272727,12.7272727 L7,12.7272727 L7,14 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.6a754ea8.svg";
export { ForwardRef as ReactComponent };